'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSO = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _class, _temp;

var _config = require('./../config');

var _config2 = _interopRequireDefault(_config);

var _Guid = require('./Guid');

var _Guid2 = _interopRequireDefault(_Guid);

var _Cookie = require('../server/Cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SSO = exports.SSO = (_temp = _class = function SSO() {
  (0, _classCallCheck3.default)(this, SSO);
}, _class.isSSO = function (query) {
  return query.operatorToken && query.operator_id;
}, _class.linkSSOToken = function (req, res, sessionId, lang, deviceId, productName, platform, features, handleUserInfoRedirection, errorRedirect, loginClient, callback) {
  var correlationId = (0, _Guid2.default)();
  var promise = loginClient.subscription.linkSSO({
    sessionId: sessionId,
    token: req.query.operatorToken,
    operatorId: req.query.operator_id,
    languageTag: lang,
    clientId: req.query.client_id,
    deviceId: deviceId
  }, { responseContentType: 'application/json', 'correlation-id': correlationId });

  promise.then(function (result) {
    handleUserInfoRedirection(req, res, result.obj, sessionId, productName, platform, features, loginClient, callback);
  });
  promise.catch(function (error) {
    errorRedirect(req, res, error, correlationId, sessionId);
  });
}, _class.ssoLogin = function (req, res, realm, lang, deviceId, productName, platform, features, handleUserInfoRedirection, errorRedirect, loginClient, callback) {
  var correlationId = (0, _Guid2.default)();
  var promise = loginClient.user.ssoLogin({
    token: req.query.operatorToken,
    operatorId: req.query.operator_id,
    languageTag: lang,
    clientId: req.query.client_id,
    deviceId: deviceId
  }, { responseContentType: 'application/json', 'correlation-id': correlationId });

  promise.then(function (result) {
    _Cookie.Cookie.saveSessionId(req, res, result.obj.sessionId, realm, _config2.default.isSecured);
    handleUserInfoRedirection(req, res, result.obj.userInfo, result.obj.sessionId, productName, platform, features, loginClient, callback);
  });
  promise.catch(function (error) {
    errorRedirect(req, res, error, correlationId);
  });
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/helpers/SSO.js
// module id = 414
// module chunks = 0